var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-signup-container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("main", [
      _c(
        "form",
        {
          staticClass: "c-signup-form",
          attrs: { autocomplete: "off", action: "POST" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.register.apply(null, arguments)
            },
          },
        },
        [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "l-stack l-stack--form" }, [
            _c(
              "div",
              {
                staticClass: "c-signup-form__field c-form__group",
                class: _vm.emailFieldClass,
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "c-form__label c-form__label--small",
                    attrs: { for: "email" },
                  },
                  [_vm._v("Email")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.emailAddress,
                      expression: "emailAddress",
                    },
                  ],
                  staticClass: "o-input",
                  attrs: {
                    id: "email",
                    type: "email",
                    placeholder: "Enter your email",
                  },
                  domProps: { value: _vm.emailAddress },
                  on: {
                    change: function ($event) {
                      return _vm.checkEmailAvailability()
                    },
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.emailAddress = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "o-text o-text--error o-text--sm o-text--700 u-mt-5",
                  },
                  [_vm._v("Please enter a valid email address.")]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "o-text o-text--warning o-text--sm o-text--700 u-mt-5",
                  },
                  [
                    _vm._v(
                      "\n              This email address is already in use. Would you like to\n              "
                    ),
                    _c(
                      "router-link",
                      { attrs: { to: { path: "/account/recovery" } } },
                      [_vm._v("resend the email verification?")]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("vue-recaptcha", {
                ref: "recaptcha",
                attrs: {
                  id: "recaptcha",
                  size: "invisible",
                  sitekey: _vm.siteKey,
                },
                on: {
                  verify: _vm.onVerifyRecaptcha,
                  expired: _vm.onExpiredRecaptcha,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "u-mt-25" }, [
            _c("input", {
              staticClass: "o-btn o-btn--primary o-btn--rounded o-btn--block",
              class: _vm.submitButtonClass,
              attrs: {
                type: "submit",
                disabled: !_vm.formValid || _vm.loading,
                value: "Create Account",
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.register.apply(null, arguments)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("footer", { staticClass: "u-mt-25" }, [
            _c(
              "p",
              { staticClass: "o-text u-fs-11" },
              [
                _vm._v("\n            Already have an account?\n            "),
                _c("router-link", { attrs: { to: { name: "Login" } } }, [
                  _c("span", { staticClass: "u-ml-5 o-text--500" }, [
                    _vm._v(" Log in "),
                  ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(2),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("aside", { staticClass: "c-signup-aside" }, [
      _c("div", { staticClass: "c-signup-aside__content" }, [
        _c("a", { attrs: { href: "/" } }, [
          _c("img", {
            staticClass: "c-signup-aside__logo",
            attrs: {
              src: "/static/images/site-logos/logo-white-h.svg",
              alt: "Logo White Horizontal",
            },
          }),
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "c-signup-aside__text" }, [
          _c("div", [
            _c("h1", { staticClass: "o-h2 u-color-white u-fw-700" }, [
              _vm._v("Welcome to Inspectiv"),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n              Inspectiv is an application security platform fueled by security researchers from around the globe who\n              help developers stay ahead of security. Companies from all sectors, including U.S. Government service\n              providers, EdTech, FinTech, Gaming, and more trust Inspectiv and its security community to keep them\n              secure.\n              "
              ),
              _c("br"),
              _vm._v(
                "\n              Our mission is to #SecureTheInternet\n            "
              ),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "c-signup-form__header u-mb-20" }, [
      _c("h2", { staticClass: "u-fw-700" }, [_vm._v("Create account")]),
      _vm._v(" "),
      _c("p", { staticClass: "o-text o-text--grey o-text--sm" }, [
        _vm._v("Become a security researcher"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "o-text u-fs-11" }, [
      _vm._v(
        "\n            Not a security researcher and looking to protect your application?\n            "
      ),
      _c(
        "a",
        {
          staticClass: "u-ml-5 o-text--500",
          attrs: { href: "mailto:sales@inspectiv.com" },
        },
        [_vm._v("Let us know")]
      ),
      _vm._v(".\n          "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }